// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/want-to-menu/want-to-menu.component.scss
// module id = 563
// module chunks = 0